import Svg, {G, type PathProps, type SvgProps} from 'react-native-svg'

import {BRAND} from '#/lib/brand'
import {BrandMarkPaths} from '#/lib/brand/BrandMarkSvg'
import {useTheme} from '#/alf'

const ratio = 17 / 64

// Brand marks are authored in a square box; scale whatever its unit size is
// to the ~27px slot in the original lockup's 136x31 footprint.
const markUnits = Number(BRAND.markViewBox.split(' ')[3]) || 24
const markScale = 27 / markUnits

export function LogomarkWithType({
  fill,
  ...rest
}: {fill?: PathProps['fill']} & SvgProps) {
  const t = useTheme()
  const size = parseInt(`${rest.width || 32}`)

  return (
    <Svg
      fill="none"
      viewBox="0 0 136 31"
      {...rest}
      width={size}
      height={Number(size) * ratio}>
      {/*
       * The brand mark centered in the original lockup's box, so callers keep
       * the same footprint.
       */}
      <G transform={`translate(54.5 2) scale(${markScale})`}>
        <BrandMarkPaths fill={(fill || t.atoms.text.color) as string} />
      </G>
    </Svg>
  )
}
